export default {
  Types: [
    { Id: 1, Text: 'enum.IssueType.DidNotGetCode', Parent: true },
    { Id: 2, Text: 'enum.IssueType.NotVoter', Parent: true },
    { Id: 4, Text: 'enum.IssueType.CouldNotFinish', Parent: true },
  ],
};
